import styled from "styled-components";

export const ScheduleGrid = styled.div`
  display: grid;
  grid-template-columns: 80px repeat(7, 1fr);
  grid-template-rows: repeat(24, 50px);
  gap: 1px;
`;

export const GridHour = styled.div`
  display: contents;
`;

export const HourLabel = styled.div`
  background-color: #202020;
  text-align: center;
  padding: 10px;
  border: 1px solid #202020;
  color: #fff;
`;

export const GridCell = styled.div`
  border: 1px solid #ddd;
  min-height: 50px;
  position: relative;
  cursor: pointer;
  transition: all 0.1s;
  &:hover{
   border: 2px solid #ddd;
  }
`;

export const LessonCard = styled.div`
  background-color: ${props => !props.iscancel? !props.issubstitute ? !props.isreschedule ? props.istrial ? '#FFC857' : '#A09EFF' : '#8DDDF7' : '#B4B4B4' : "#ff7f7f"};
  padding: 3px 5px;
  margin: 5px;
 
  border-radius: 5px;
  position: absolute;
  width: calc(100% - 10px);
  box-sizing: border-box;
  z-index: 1;
  cursor: pointer;
  transition: opacity 0.3s ease-in-out;
  &:hover{
    opacity: 0.7;
  }
`;

export const StudentName = styled.p`
  font-family: Raleway;
  font-weight: 600;
  color: #00000;
  font-size: 0.9em;
`

export const LessonTime = styled.p`

  font-weight: 400;
  color: #fff;
  font-size: 0.8em;
`

export const DeleteSlotButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(255, 255, 255, 0.7);
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  z-index: 2;
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 0, 0, 0.7);
    color: white;
  }
`;


export const ToggleWrapper = styled.div`
  display: flex;
  margin-bottom: 12px;
  justify-content: flex-end;
  gap: 8px;
`;

export const ToggleButton = styled.button`
  padding: 6px 12px;
  border: none;
  background-color: ${({ active }) => (active ? "#A09EFF" : "#e0e0e0")};
  color: ${({ active }) => (active ? "#fff" : "#333")};
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;